/**
 * @description 腾讯视频 Phone/Pad Js bridge统一适配
 * @author aprilcai
 */

import { parseBridgeResult } from './util';
import EventEmitter, { F } from './event-emitter';

// 消息队列
const message = new EventEmitter();
let injected = false;

// 在原来的TenvideoJSBridge方法上面增加注入实现
function $inject() {
  const bridge = window.TenvideoJSBridge;
  if (injected) return;
  injected = false;

  bridge.$once = (event: string, cb: Function) => {
    const method = 'on';
    message.once(event, cb);
    bridge[method](event, (res: any) => {
      message.emit(event, parseBridgeResult(res));
    });
  };

  bridge.$on = (event: string, cb: F) => {
    const method = 'on';
    message.on(event, cb);
    bridge[method](event, (res: any) => {
      message.emit(event, parseBridgeResult(res));
    });
  };

  bridge.$off = (event: string, cb: F) => {
    message.off(event, cb);
  };

  bridge.$invokeAsync = async function (api: string, param: any) {
    return new Promise((resolve) => {
      bridge.$invoke(api, param, (res: any) => {
        resolve(res);
      });
    });
  };

  bridge.$invoke = (api: string, param: any, cb: F) => {
    const method = 'invoke';
    bridge[method](
      api,
      param,
      (res: any) => {
        const result = parseBridgeResult(res);
        if (typeof cb === 'function') {
          cb(result);
        }
      },
      'fromh5',
    );

    // android下openUrl并不会回调，这里实现一个
    if (/android/i.test(navigator.userAgent)) {
      if (api === 'openUrl') {
        setTimeout(() => {
          cb({
            errCode: 0,
            errMsg: 'ok',
          });
        });
      }
    }
  };
}

// 连接bridge
export function connectTenvideoJSBridge(callback: Function) {
  if (window.TenvideoJSBridge) {
    $inject();
    callback(window.TenvideoJSBridge);
  } else {
    document.addEventListener(
      'onTenvideoJSBridgeReady',
      () => {
        $inject();
        callback(window.TenvideoJSBridge);
      },
      false,
    );
  }
}

// 获取bridge
export async function getBridge(): Promise<IBridge> {
  return new Promise((resolve) => {
    connectTenvideoJSBridge(resolve);
  });
}

export async function onceAsync(event: string): Promise<BridgeResult> {
  const bridge = await getBridge();
  return new Promise((resolve) => {
    bridge.$once(event, resolve);
  });
}

// 异步invoke
export async function invokeAsync(api: string, param: any): Promise<BridgeResult> {
  const bridge = await getBridge();
  return new Promise((resolve) => {
    bridge.$invoke(api, param, resolve);
  });
}

// once
export function once(event: string, callback: Function): void {
  getBridge().then((bridge) => {
    bridge.$once(event, callback);
  });
}
